// extracted by mini-css-extract-plugin
export var asterisk = "OutlinedInput-module--asterisk--da7a5";
export var focusTest = "OutlinedInput-module--focusTest--3a120";
export var labelFocused = "OutlinedInput-module--labelFocused--b29ee";
export var labelFocusedError = "OutlinedInput-module--labelFocusedError--9221a";
export var notchedOutline = "OutlinedInput-module--notchedOutline--0ceb4";